import React from 'react';
import { Checkbox } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(Checkbox)();
